import React, { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import * as cardsStyles from '../cards.module.scss';
import ViewCardLimit from "./view_card_limit";
import EditCardLimit from "./edit_card_limit";
import { utils } from "../../../utils/utils";
import { useSelector } from "react-redux";
import { selectAreas } from "../../../state/selectors/tanks";
import { selectApplicationSettings } from "../../../state/selectors/app";

const emptyLimit = {
    limitId: "00000000-0000-0000-0000-000000000000",
    autoCardId: "00000000-0000-0000-0000-000000000000",
    userCardId: "00000000-0000-0000-0000-000000000000",
    limitState: 0,
    fuelType: "",
    dayLimit: 0.0,
    monthLimit: 0.0,
    dateLimit: 0.0,
    endDate: new Date().toISOString(),
    dayVolume: 0.0,
    monthVolume: 0.0,
    totalVolume: 0.0,
    movingTs: new Date().toISOString(),
    movingNumber: ""
};

const CardLimits = ({ cardId, userCardId, limits, setLimits }) => {
    const areas = useSelector(store => selectAreas()(store));
    const appSettings = useSelector(store => selectApplicationSettings()(store))
    const [existingFuelTypes, setExistingFuelTypes] = useState([]);
    const [isAddLimitBtnEnabled, setIsAddLimitBtnEnabled] = useState(false);
    const [isLimitsEditable, setIsLimitsEditable] = useState(false);
    // const [isLimitsAvailable, setIsLimitsAvailable] = useState(false);
    const limitsAvailableSetting = appSettings.find(s => s.name === "LimitsAvailable");
    const isLimitsAvailable = limitsAvailableSetting && limitsAvailableSetting.value;

    useEffect(() => {
        setLimitsState();
    }, [limits, areas])

    const setLimitsState = () => {
        const fuelTypes = areas.map(area => area.tanks.map(tank => tank.fuelType)).reduce((a, b) => a.concat(b), [])
            .filter((fyelType, index, arr) => arr.indexOf(fyelType) === index).sort();

        const existingFt = getFuelTypes(fuelTypes);
        const isAdd = limits.filter((item) => item.isEditable === true).length === 0 && existingFt.length > 0;
        const isEdit = limits.filter((item) => item.isEditable === true).length === 0;
        setIsAddLimitBtnEnabled(isAdd);
        setIsLimitsEditable(isEdit);
        setExistingFuelTypes(existingFt);
    }

    const cancelEditLimit = (limitId) => {
        const lmts = [...limits];

        const newLimits = lmts.map((item, index) => {
            if (item.item.limitId !== limitId) {
                // isn't the item we care about - keep it as-is
                return item;
            }

            item.isEditable = false;
            return item;
        });

        setLimits(newLimits);
    }

    const addNewLimit = (newLimit) => {
        const ft = getFuelTypes(existingFuelTypes);
        const lmts = [...limits];
        newLimit.item.limitId = utils.generateUuid();
        newLimit.item.fuelType = ft ? ft[0] : "";
        newLimit.item.endDate = utils.toLocalNetString(new Date());
        newLimit.item.autoCardId = cardId;
        newLimit.item.userCardId = userCardId;
        newLimit.item.limitState = 1;

        lmts.unshift(newLimit);

        setLimits(lmts);
    }

    const editLimit = (limitId) => {
        const lmts = [...limits];
        const newLimits = lmts.map((item, index) => {
            if (item.item.limitId !== limitId) {
                // isn't the item we care about - keep it as-is
                return item;
            }

            item.isEditable = true;
            return item;
        });
        setLimits(newLimits);
    }

    const saveLimit = (limit) => {
        const lim = { item: limit, isEditable: false, isNew: false };
        const lmts = [...limits];
        const newLimits = lmts.map((item, index) => {
            if (item.item.limitId !== limit.limitId) {
                // isn't the item we care about - keep it as-is
                return item;
            }

            // Otherwise, is the one we want - return an updated value
            return {
                ...item,
                ...lim
            }
        });

        setLimits(newLimits);
    }

    const addLimit = (e) => {
        e.preventDefault();
        const newLimit = { item: Object.assign({}, emptyLimit), isEditable: true, isNew: true };
        addNewLimit(newLimit);
    }

    const getFuelTypes = (ftypes) => {
        const ft = ftypes.filter(item => {
            return (limits.find((l) => (l.item.fuelType === item) && l.isEditable === false)) ? false : true;
        });

        return ft;
    }

    const removeLimit = (limit) => {
        let lmts = [...limits];
        lmts = lmts.filter((item, index, arr) => item.item.limitId !== limit.limitId);
        setLimits(lmts);
    }


    return (
        <>
            {
                isLimitsAvailable &&
                <div className={cardsStyles.card_limits}>
                    <div className="margin10">
                        <div className={cardsStyles.card_limit_header}>
                            <div>
                                <Trans>Limits.cardLimitsHeader</Trans>
                            </div>
                            <div>
                                {isAddLimitBtnEnabled && <button className={cardsStyles.add_card_limit_btn} onClick={addLimit}></button>}
                            </div>
                        </div>
                        <div>
                            {
                                limits &&
                                limits.map((limit) => {
                                    return <div key={limit.item.limitId} className="flex-column-border-content">
                                        {
                                            !limit.isEditable &&
                                            <ViewCardLimit key={limit.item.limitId}
                                                item={limit.item}
                                                fuelTypes={existingFuelTypes}
                                                editAction={editLimit}
                                                removeAction={removeLimit}
                                                canEdit={isLimitsEditable} />
                                        }
                                        {
                                            limit.isEditable &&
                                            <EditCardLimit key={limit.item.limitId}
                                                item={limit.item}
                                                fuelTypes={existingFuelTypes}
                                                isNew={limit.isNew}
                                                saveAction={saveLimit}
                                                removeAction={removeLimit}
                                                cancelEditAction={cancelEditLimit} />
                                        }
                                    </div>;
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </>

    )
}

export default CardLimits;